<template>
  <Select filterable remote clearable
          @on-change="onChange" :placeholder="placeNum"
          :remote-method="remoteMethod" :loading="loading" transfer ref="timeZone">
    <Option v-for="item in items"
            :value="item.num" :key="item.num">
            {{item.name.word + '----------------时差：' + item.num}}
    </Option>
  </Select>
</template>
<script>
  export default {
    name: 'TimeZoneSelect',
    props: {
      value: {
        type: [Number, String]
      },
      label: {
        type: String
      },
      timeZoneValue: {
        type: [Number, String]
      }
    },
    data () {
      return {
        loading: false,
        model: this.value,
        items: null,
        arr: [],
        placeNum: '',
        timeZones: this.$timeZone.timeZone
      }
    },
    methods: {
      remoteMethod (query) {
//        console.log('remoteMethod query:' + query)
        query = query === null ? '' : query.trim()
        if (query === null || query === '') {
          this.items = []
          return
        }
        let self = this
        self.arr = []
        self.loading = true
        for (var index = 0; index < self.timeZones.length; index++) {
          if (self.timeZones[index].name.word.indexOf(query) >= 0) {
            self.arr.push(self.timeZones[index])
          }
        }
        self.items = self.arr
        self.loading = false
      },
      getByValue (query) {
//        console.log('getByValue query:' + query)
        if (query === null || query === '') {
          return ''
        }
        let self = this
        for (var index = 0; index < self.timeZones.length; index++) {
          if (self.timeZones[index].num === query) {
            return self.timeZones[index].name.word + '----------------时差：' + self.timeZones[index].num
          }
        }
      },
      onChange (obj) {
//        console.log('onChange value:' + JSON.stringify(obj))
        this.$emit('input', obj)
        this.$emit('on-change', obj)
      }
    },
    mounted: function () {
    },
    watch: {
      value (val) {
        this.model = val
      },
      timeZoneValue (val) {
//        console.log('timeZoneValue:' + val)
        this.$refs.timeZone.clearSingleSelect()
        if (!val) {
          this.placeNum = ''
        }
        if (val) {
          this.placeNum = this.getByValue(val)
//          this.remoteMethod(val)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TimeZoneSelect.vue?b48ccc9a